import React from 'react'


const SelectGender = (props) => (
	<div className='fineryCard' style={props.swipeStyle} >
		<div className='fineryCardContent'>
			<h2 className='firstThings'>FIRST THINGS FIRST, ARE YOU A…</h2>
      <div onClick={()=>props.onNextPage('m')} className='fineryGenderButton'>Male</div>
      <div onClick={()=>props.onNextPage('f')} className='fineryGenderButton'>Female</div>
      </div>
	</div>
)
export default SelectGender;



// WEBPACK FOOTER //
// ./src/templates/SelectGender.js